// extracted by mini-css-extract-plugin
export default {"root":"DM82y","wrapper":"nOU0Y","left":"_cNuW","right":"p9Px3","center":"wNvlS"};